import { invoiceActions } from "../../actionTypes";

const initialState = {
	invoiceLocation: {},
	fetching: false,
	fetched: false,
	error: null,
};

const Reducer = (state = initialState, action) => {
	switch (action.type) {
		case invoiceActions.FETCH_INVOICE_LOCATION: {
			return { ...state, ...initialState };
		}

		case invoiceActions.FETCH_INVOICE_LOCATION_FULFILLED: {
			return {
				...state,
				fetching: false,
				fetched: true,
				invoiceLocation: action.payload,
			};
		}

		case invoiceActions.FETCH_INVOICE_LOCATION_REJECTED: {
			return { ...state, fetching: false, error: action.payload };
		}

		default:
	}

	return state;
};

export default Reducer;
